export var LOGGER_NAME = 'snowplow';
//# sourceMappingURL=constants.js.map